import React from "react"
import MapShape2 from "../../images/shape/map-shape2.png"
import starIcon from "../../images/star-icon.png"

const WhoWeAre = ({ data }) => {
    const imageUrl = data?.image?.url
  ? `${process.env.REACT_APP_UPLOAD_URL}${data.image.url}`
  : "";
    return (
        <>
            <section className="why-choose-us-area bg-color ptb-70 overflow-hidden">
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-6 col-md-12" data-aos="fade-up" data-aos-duration="1200">
                            <div className="why-choose-us-content section-title text-lg-start">
                                <span className="sub-title">
                                    <img src={starIcon} alt="banner" />
                                    {data.title && <h2>{data.title}</h2>}
                                </span>
                                {data?.description?.map((block, index) => {
                                    switch (block.type) {
                                        case "paragraph":
                                            return (
                                                <p key={index}>
                                                    {block.children.map(c => c.text).join("")}
                                                </p>
                                            );

                                        case "heading":
                                            const Tag = `h${block.level}`;
                                            return (
                                                <Tag key={index} className="mt-4 mb-3">
                                                    {block.children.map(c => c.text).join("")}
                                                </Tag>
                                            );

                                        case "list":
                                            return (
                                                <ul key={index} className="list-unstyled">
                                                    {block.children.map((item, i) => (
                                                        <li key={i} className="features-text">
                                                            <h4>
                                                                <i className="flaticon-tick"></i>{" "}
                                                                {item.children.map(c => c.text).join("")}
                                                            </h4>
                                                        </li>
                                                    ))}
                                                </ul>
                                            );

                                        default:
                                            return null;
                                    }
                                })}

                                <div className="map-shape2">
                                    <img src={MapShape2} alt="MapShape" />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-12" data-aos="fade-up" data-aos-duration="1200">
                            {/* <div className="our-brand-partners-list who-we-are-area ">
                                <DynamicImage image={data?.image} />
                            </div> */}
                            <div
  className="our-brand-partners-list who-we-are-area"
  style={{
    backgroundImage: imageUrl ? `url(${imageUrl})` : "none",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
</div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default WhoWeAre